import { render, staticRenderFns } from "./PageOpenCalls.vue?vue&type=template&id=68b6c1a2&scoped=true&"
import script from "./PageOpenCalls.vue?vue&type=script&lang=js&"
export * from "./PageOpenCalls.vue?vue&type=script&lang=js&"
import style0 from "./PageOpenCalls.vue?vue&type=style&index=0&id=68b6c1a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b6c1a2",
  null
  
)

export default component.exports